<div class="person-payments-table py-4">
  <!-- 100% del ancho disponible en pantallas chicas; contenido y centrado (tope 1320px) en grandes. -->
  <div class="ppt-wrap mx-auto px-4">

  <!-- ============== Carga inicial (hasta tener persona + primera página) ============== -->
  <div *ngIf="loadingInitial" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>
    <p class="mt-3 text-muted">Cargando información...</p>
  </div>

  <ng-container *ngIf="!loadingInitial">

  <!-- ============== Header de la persona (idéntico a la vista clásica) ============== -->
  <div *ngIf="person?.person" class="mb-4">
    <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
      <div [routerLink]="['/console/person/profile/', person?.person?.code]"
           class="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity">
        <div class="flex-shrink-0">
          <img *ngIf="person?.person?.file_selfie"
               class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
               [src]="sanitize(person?.person?.file_selfie?.url)" alt="Avatar del cliente" />
          <img *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
               class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
               [src]="sanitize('../assets/public/images/avatar.png')" alt="Avatar del cliente" />
          <img *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
               class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
               [src]="sanitize('../assets/public/images/avatara-female.png')" alt="Avatar del cliente" />
        </div>
        <div class="flex-1">
          <h2 class="text-xl font-bold text-gray-900 capitalize hover:text-blue-600 transition-colors">
            {{ person?.person?.name }} {{ person?.person?.lastName }}
          </h2>
          <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
            <div class="flex items-center gap-1">
              <i class="fas fa-id-card text-blue-600"></i>
              <span>{{ getIdentity(person) }}</span>
            </div>
            <div class="flex items-center gap-1">
              <i class="fas fa-phone text-blue-600"></i>
              <span>{{ getContact(person) }}</span>
            </div>
            <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
              <i class="fas fa-envelope text-blue-600"></i>
              <span>{{ getEmailContact(person) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============== Título (homologado con la vista clásica) ============== -->
  <div class="mb-3">
    <h1 class="text-2xl font-bold text-gray-900 text-center">
      <i class="fas fa-money-bill-wave text-blue-600 mr-2"></i>
      Pagos realizados
    </h1>
    <p class="text-center text-muted small mb-0">{{ total }} pago{{ total === 1 ? '' : 's' }}</p>
  </div>

  <!-- ============== Barra de filtros (colapsable) ============== -->
  <div class="bg-white rounded shadow-sm border mb-3 ppt-filters">

    <button type="button"
            class="d-flex align-items-center gap-2 w-100 px-3 py-2 ppt-filters-head ppt-filters-toggle"
            [class.border-bottom]="showFilters"
            (click)="toggleFilters()">
      <i class="fas fa-sliders-h text-primary"></i>
      <span class="fw-semibold text-secondary small text-uppercase">Filtros</span>
      <span *ngIf="activeFilterCount > 0" class="badge rounded-pill text-bg-primary ppt-filter-count">
        {{ activeFilterCount }}
      </span>
      <span *ngIf="!showFilters && activeFilterCount === 0" class="text-muted small fst-italic">
        Mostrar filtros de búsqueda
      </span>
      <i class="fas ms-auto text-muted" [ngClass]="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>

    <div class="p-3" *ngIf="showFilters">
      <div class="row g-3 align-items-end">

        <!-- Estatus -->
        <div class="col-12 col-sm-6 col-lg-3">
          <label class="form-label ppt-filter-label">Estatus</label>
          <div class="input-group input-group-sm">
            <span class="input-group-text"><i class="fas fa-check-circle"></i></span>
            <select class="form-select" [(ngModel)]="filters.type">
              <option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</option>
            </select>
          </div>
        </div>

        <!-- Tipo de producto (multiselect) -->
        <div class="col-12 col-sm-6 col-lg-3 position-relative">
          <label class="form-label ppt-filter-label">Tipo de producto</label>
          <div class="input-group input-group-sm">
            <span class="input-group-text"><i class="fas fa-box"></i></span>
            <button type="button" class="form-select text-start text-truncate" (click)="toggleProductDropdown()">
              {{ productLabel }}
            </button>
          </div>
          <div class="product-dropdown shadow border rounded bg-white" *ngIf="showProductDropdown">
            <div class="px-2 py-1 small text-muted border-bottom">Selecciona productos</div>
            <div class="product-dropdown-body">
              <label *ngFor="let item of productArray"
                     class="d-flex align-items-center gap-2 px-2 py-1 product-option mb-0">
                <input type="checkbox"
                       [checked]="isProductSelected(item?.params?.code)"
                       (change)="toggleProduct(item?.params?.code, $any($event.target).checked)" />
                <span class="small">{{ item?.params?.name || item?.params?.code }}</span>
              </label>
            </div>
            <div class="px-2 py-1 border-top text-end">
              <button class="btn btn-sm btn-primary" (click)="showProductDropdown=false">Listo</button>
            </div>
          </div>
        </div>

        <!-- Banco origen -->
        <div class="col-12 col-sm-6 col-lg-3">
          <label class="form-label ppt-filter-label">Banco origen</label>
          <div class="input-group input-group-sm">
            <span class="input-group-text"><i class="fas fa-university"></i></span>
            <select class="form-select" [(ngModel)]="filters.bank">
              <option value="">Todos</option>
              <option *ngFor="let b of bankList" [value]="b?.bankCode">{{ b?.name }}</option>
            </select>
          </div>
        </div>

        <!-- Referencia -->
        <div class="col-12 col-sm-6 col-lg-3">
          <label class="form-label ppt-filter-label">Referencia</label>
          <div class="input-group input-group-sm">
            <span class="input-group-text"><i class="fas fa-hashtag"></i></span>
            <input type="text" class="form-control" placeholder="N° de referencia"
                   [(ngModel)]="filters.reference" (keyup.enter)="applyFilters()" />
          </div>
        </div>

        <!-- Monto -->
        <div class="col-12 col-sm-6 col-lg-4">
          <label class="form-label ppt-filter-label">Monto (USD)</label>
          <div class="input-group input-group-sm">
            <span class="input-group-text"><i class="fas fa-dollar-sign"></i></span>
            <input type="number" class="form-control" placeholder="Mínimo" [(ngModel)]="filters.amount_min" />
            <span class="input-group-text px-2">—</span>
            <input type="number" class="form-control" placeholder="Máximo" [(ngModel)]="filters.amount_max" />
          </div>
        </div>

        <!-- Fecha de pago -->
        <div class="col-12 col-sm-6 col-lg-5">
          <label class="form-label ppt-filter-label">Fecha de pago (comprobante)</label>
          <div class="input-group input-group-sm">
            <span class="input-group-text"><i class="fas fa-calendar-day"></i></span>
            <input type="date" class="form-control" [(ngModel)]="filters.init" title="Desde" />
            <span class="input-group-text px-2">a</span>
            <input type="date" class="form-control" [(ngModel)]="filters.end" title="Hasta" />
          </div>
        </div>

      </div>

      <!-- Acciones de filtro -->
      <div class="d-flex gap-2 justify-content-end mt-3 pt-3 border-top">
        <button class="btn btn-sm btn-light border" (click)="clearFilters()">
          <i class="fas fa-eraser me-1"></i> Limpiar
        </button>
        <button class="btn btn-sm btn-primary px-3" (click)="applyFilters()">
          <i class="fas fa-search me-1"></i> Aplicar filtros
        </button>
      </div>
    </div>
  </div>

  <!-- ============== Tabla ============== -->
  <div class="bg-white rounded shadow-sm border position-relative">

    <!-- Loading overlay -->
    <div *ngIf="loading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>
    </div>

    <!-- Vista tabla (solo desktop ancho); en pantallas chicas se reorganiza en tarjetas. -->
    <div class="ppt-table-wrap d-none d-lg-block">
      <table class="table table-hover align-middle mb-0 ppt-table">
        <thead>
          <tr>
            <th>Fechas</th>
            <th class="d-none d-md-table-cell">Producto</th>
            <th>Banco / Método</th>
            <th>Referencia</th>
            <th class="text-end">Monto</th>
            <th class="text-center">Estatus</th>
            <th *ngIf="verLiq">Liquidación al comercio</th>
            <th class="text-end">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackByCode" class="ppt-row" (click)="openDetail(row)">
            <td class="ppt-dates text-nowrap">
              <div>
                <span class="ppt-date-tag">Pago</span>
                <span class="fw-semibold">{{ (row?.payment?.register_payment_date || row?.payment?.date) | date:'dd/MM/yyyy' }}</span>
              </div>
              <div class="ppt-xs text-muted">
                <span class="ppt-date-tag">Reg.</span>{{ row?.payment?.date | date:'dd/MM/yyyy' }}
              </div>
              <div class="ppt-xs text-muted" *ngIf="row?.payment?.reconciled_payment_date">
                <span class="ppt-date-tag">Concil.</span>{{ row?.payment?.reconciled_payment_date | date:'dd/MM/yyyy' }}
              </div>
              <span class="d-md-none d-block text-muted ppt-xs mt-1">{{ row?.payment?.typeProduct || 'CREDIT' }}</span>
            </td>
            <td class="d-none d-md-table-cell">
              <span class="badge rounded-pill text-bg-light border">{{ row?.payment?.typeProduct || 'CREDIT' }}</span>
            </td>
            <td>
              <ng-container *ngIf="isInicial(row?.payment); else bankCol">
                <span class="badge rounded-pill text-bg-info">Inicial</span>
              </ng-container>
              <ng-template #bankCol>
                <div class="fw-semibold ppt-ellipsis">{{ bankName(row?.payment) }}</div>
                <div class="text-muted ppt-xs ppt-ellipsis">{{ row?.payment?.account_payment?.payment_method?.name || '-' }}</div>
              </ng-template>
            </td>
            <td>
              <span class="ppt-ref" [title]="row?.payment?.paymentMethodId || ''">{{ row?.payment?.paymentMethodId || '-' }}</span>
            </td>
            <td class="text-end text-nowrap">
              <div class="fw-semibold">{{ row?.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
              <div class="text-muted ppt-xs" *ngIf="row?.payment?.counterValue">
                {{ row?.payment?.counterValue | number:'1.2-2' }} {{ row?.payment?.currency?.code || 'BS' }}
              </div>
            </td>
            <td class="text-center">
              <span class="badge rounded-pill" [ngClass]="getStatusClass(row?.payment)">{{ getStatusLabel(row?.payment) }}</span>
            </td>
            <!-- Liquidación al comercio (EST-03; maqueta escenario 5): tocarla abre la traza del pago en Consultas. -->
            <td *ngIf="verLiq" (click)="$event.stopPropagation()">
              <ng-container *ngIf="marcas[row?.payment?._id] as mk; else sinMarcappt">
                <span class="mr-1 inline-flex items-center gap-1 align-middle"><app-estampa-comercio *ngFor="let c of (mk.comercios || [])" [codigo]="c" [tam]="20"></app-estampa-comercio></span>
                <a class="kb-badge !no-underline" [ngClass]="claseMarca(mk.estado)" [title]="mk.texto"
                   [routerLink]="mk.liquidacion ? null : ['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', pago: row?.payment?._id }"
                   (click)="mk.liquidacion && fichaLiq.abrir(mk.liquidacion)">{{ etiquetaPago(mk) }}</a>
              </ng-container>
              <ng-template #sinMarcappt><span class="text-muted ppt-xs">—</span></ng-template>
            </td>
            <td class="text-end" (click)="$event.stopPropagation()">
              <ng-container *ngTemplateOutlet="actionsMenu; context: { row: row }"></ng-container>
            </td>
          </tr>

          <!-- Empty state -->
          <tr *ngIf="!loading && loaded && rows.length === 0">
            <td [attr.colspan]="verLiq ? 8 : 7" class="text-center text-muted py-5">
              <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
              No se encontraron pagos con los filtros aplicados.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Vista tarjetas (móvil/tablet): toda la info reorganizada, sin ocultar nada. -->
    <div class="d-lg-none ppt-cards">
      <div class="ppt-card" *ngFor="let row of rows; trackBy: trackByCode" (click)="openDetail(row)">
        <div class="d-flex justify-content-between align-items-start gap-2">
          <div class="min-w-0">
            <div class="fw-semibold">{{ (row?.payment?.register_payment_date || row?.payment?.date) | date:'dd/MM/yyyy' }}</div>
            <div class="text-muted ppt-xs">Reg. {{ row?.payment?.date | date:'dd/MM/yyyy' }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
            <span class="badge rounded-pill" [ngClass]="getStatusClass(row?.payment)">{{ getStatusLabel(row?.payment) }}</span>
            <ng-container *ngTemplateOutlet="actionsMenu; context: { row: row }"></ng-container>
          </div>
        </div>

        <div class="ppt-card-grid mt-2">
          <div>
            <div class="ppt-card-label">Monto</div>
            <div class="fw-semibold">{{ row?.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
            <div class="text-muted ppt-xs" *ngIf="row?.payment?.counterValue">
              {{ row?.payment?.counterValue | number:'1.2-2' }} {{ row?.payment?.currency?.code || 'BS' }}
            </div>
          </div>
          <div>
            <div class="ppt-card-label">Banco / Método</div>
            <ng-container *ngIf="isInicial(row?.payment); else bankCardCol">
              <span class="badge rounded-pill text-bg-info">Inicial</span>
            </ng-container>
            <ng-template #bankCardCol>
              <div class="ppt-xs">{{ bankName(row?.payment) }}</div>
              <div class="text-muted ppt-xs">{{ row?.payment?.account_payment?.payment_method?.name || '-' }}</div>
            </ng-template>
          </div>
          <div>
            <div class="ppt-card-label">Referencia</div>
            <div class="ppt-ref">{{ row?.payment?.paymentMethodId || '-' }}</div>
          </div>
          <div>
            <div class="ppt-card-label">Producto</div>
            <div class="ppt-xs">{{ row?.payment?.typeProduct || 'CREDIT' }}</div>
          </div>
        </div>

        <div class="mt-2" *ngIf="verLiq && marcas[row?.payment?._id] as mk" (click)="$event.stopPropagation()">

          <div class="ppt-card-label">Liquidación al comercio</div>

          <span class="mr-1 inline-flex items-center gap-1 align-middle"><app-estampa-comercio *ngFor="let c of (mk.comercios || [])" [codigo]="c" [tam]="20"></app-estampa-comercio></span>
          <a class="kb-badge !no-underline" [ngClass]="claseMarca(mk.estado)" [title]="mk.texto"

             [routerLink]="mk.liquidacion ? null : ['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', pago: row?.payment?._id }"
                   (click)="mk.liquidacion && fichaLiq.abrir(mk.liquidacion)">{{ etiquetaPago(mk) }}</a>

        </div>

        <div class="text-center mt-2">
          <small class="text-primary"><i class="fas fa-hand-pointer me-1"></i>Toca para ver el detalle</small>
        </div>
      </div>

      <div *ngIf="!loading && loaded && rows.length === 0" class="text-center text-muted py-5">
        <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
        No se encontraron pagos con los filtros aplicados.
      </div>
    </div>

    <!-- ============== Paginación ============== -->
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 px-3 py-2 border-top" *ngIf="total > 0">
      <div class="d-flex align-items-center gap-3 flex-wrap">
        <div class="small text-secondary">
          Mostrando {{ rangeStart }}–{{ rangeEnd }} de {{ total }}
        </div>
        <div class="d-flex align-items-center gap-1 small text-secondary">
          <span>Mostrar</span>
          <select class="form-select form-select-sm w-auto ppt-pagesize"
                  [ngModel]="limit" (ngModelChange)="changePageSize($event)">
            <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
          </select>
          <span>por página</span>
        </div>
      </div>
      <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="page === 1">
            <button class="page-link" (click)="goToPage(1)">«</button>
          </li>
          <li class="page-item" [class.disabled]="page === 1">
            <button class="page-link" (click)="goToPage(page - 1)">‹</button>
          </li>
          <li class="page-item" *ngFor="let p of pageNumbers" [class.active]="p === page">
            <button class="page-link" (click)="goToPage(p)">{{ p }}</button>
          </li>
          <li class="page-item" [class.disabled]="page === totalPages">
            <button class="page-link" (click)="goToPage(page + 1)">›</button>
          </li>
          <li class="page-item" [class.disabled]="page === totalPages">
            <button class="page-link" (click)="goToPage(totalPages)">»</button>
          </li>
        </ul>
      </nav>
    </div>

  </div>

  </ng-container>
  </div>
</div>

<!-- ============== Modal de detalle (reusa el componente clásico en modo modal) ============== -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-receipt text-primary me-2"></i>Detalle del pago {{ selectedRow?.payment?.code }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <app-person-payments [code_payment]="selectedRow?.payment?.code" [code_person]="personCode"></app-person-payments>
  </div>
</ng-template>

<!-- ============== Modal visor de comprobante (idéntico a la vista clásica) ============== -->
<ng-template #fileViewerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-image me-2"></i>Comprobante de pago</h5>
    <button type="button" class="btn-close" (click)="closeFileModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body text-center p-4" style="display: flex; align-items: center; justify-content: center; min-height: 400px;">
    <div *ngIf="selectedFileType === 'image'" class="image-container" style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <img [src]="selectedFileUrl"
           alt="Comprobante de pago"
           class="img-fluid rounded shadow-sm"
           style="max-width: 100%; max-height: 70vh; object-fit: contain; display: block; margin: 0 auto;"
           (error)="selectedFileType = 'error'">
    </div>

    <div *ngIf="selectedFileType === 'error'" class="text-center">
      <i class="fas fa-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
      <h5 class="mt-3">No se pudo cargar la imagen</h5>
      <p class="text-muted">La imagen no se puede visualizar en el navegador.</p>
      <a [href]="selectedFileUrl" target="_blank" class="btn btn-primary mt-2">
        <i class="fas fa-external-link-alt me-1"></i>
        Abrir en nueva pestaña
      </a>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-primary" (click)="downloadCurrentFile()">
      <i class="fas fa-download me-1"></i>
      Descargar
    </button>
    <button type="button" class="btn btn-secondary" (click)="closeFileModal()">
      <i class="fas fa-times me-1"></i>
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ============== Menú de acciones (reutilizado por tabla y tarjetas) ============== -->
<ng-template #actionsMenu let-row="row">
  <div ngbDropdown container="body" placement="bottom-end" class="d-inline-block">
    <button type="button" class="btn btn-sm btn-outline-secondary" ngbDropdownToggle title="Acciones">
      <i class="fas fa-ellipsis-v"></i>
    </button>
    <div ngbDropdownMenu>
      <button ngbDropdownItem (click)="openDetail(row)">
        <i class="fas fa-eye me-2 text-info"></i> Ver detalle
      </button>
      <button ngbDropdownItem *ngIf="row?.payment?.file" (click)="redirectIMG(row?.payment?.file, fileViewerModal)">
        <i class="fas fa-receipt me-2 text-secondary"></i> Ver comprobante
      </button>
      <button ngbDropdownItem
              *ngIf="canEdit() && !row?.payment?.reconciled_payment && row?.payment?.status && row?.payment?.typeTransaction !== 'PENDING'"
              (click)="setPayment(row)">
        <i class="far fa-edit me-2 text-primary"></i> Editar
      </button>
      <ng-container *ngIf="canShowActions(row?.payment)">
        <button ngbDropdownItem *ngIf="canApprove()" [disabled]="loadcon" (click)="concilidarPago(row?.payment)">
          <i class="fas fa-check me-2 text-success"></i> Aprobar
        </button>
        <button ngbDropdownItem *ngIf="canCancel()" [disabled]="loadcon2" (click)="cancelPayment(row?.payment?.code)">
          <i class="fas fa-times me-2 text-danger"></i> Anular
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
